module.exports = __webpack_public_path__ + "static/scale-model-of-ann-arbor-michigan-d955b56eb0d48de634c5eb0fca130bf5.png";